// extracted by mini-css-extract-plugin
export default {"countrySelector":"registration_countrySelector__k02q1","smallFont":"registration_smallFont__pMANg","fullwidth":"registration_fullwidth__A62uC"};